import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { PERMISSIONS } from '@/lib/rbac'
import { BotManagementPage } from '@/features/bot/bot-management-page'

export const Route = createFileRoute('/_authenticated/bot')({
  beforeLoad: async () => {
    const { auth } = useAuthStore.getState()

    // Check if user has system admin permissions
    if (!auth.canAccess([PERMISSIONS.SYSTEM.ADMIN])) {
      throw redirect({
        to: '/unauthorized',
      })
    }
  },
  component: BotManagementPage,
})
